import { HttpError, isError } from "../helpers/Error"
import { ACTION_FAIL, ACTION_SENT, ACTION_SUCCESS } from "./ActionLog"
import { LOG_ACTION } from "./actionLogActionTypes"

export function dispatchActionSuccess(actionId: string, payload) {
    return {
        type: LOG_ACTION,
        payload: {
            actionId: actionId,
            status: ACTION_SUCCESS,
            time: Date.now(),
            result: payload
        }
    }
}

export function dispatchActionError(actionId: string, payload: object) {
    return {
        type: LOG_ACTION,
        payload: {
            actionId: actionId,
            status: ACTION_FAIL,
            time: Date.now(),
            error: payload,
        }
    }
}

export function dispatchActionRequest(actionId: string) {
    return {
        type: LOG_ACTION,
        payload: {
            actionId: actionId,
            status: ACTION_SENT,
            time: Date.now(),
        }
    }
}

export type Callback<T> = (x?: T) => void
export type ArrayCallback<T> = (x?: T[]) => void
export function requestAction<T>(
    request: () => Promise<T | T[] | HttpError>,
    onSuccess: Callback<T> | ArrayCallback<T>,
    actionId: string,
) {
    return async (dispatch) => {
        dispatch(dispatchActionRequest(actionId))
        const obj = await request()
        if (isError(obj)) {
            dispatch(dispatchActionError(actionId, obj as HttpError))
            return
        }
        // @ts-ignore
        const isArray = Array.isArray((obj).data)
        if (isArray) {
            dispatch((onSuccess as ArrayCallback<T>)(obj as T[]))
        } else {
            dispatch((onSuccess as Callback<T>)(obj as T))
        }
        dispatch(dispatchActionSuccess(actionId, obj))
    }
}




// WEBPACK FOOTER //
// ./src/state/actionlog/actionLogActions.ts